import React from "react";
import { Card, Divider, FormLayout, Grid, InlineStack, SkeletonBodyText, SkeletonDisplayText, SkeletonThumbnail, BlockStack, Bleed, Banner } from "@shopify/polaris";
import '../css/skeleton.css';

export const RenderSkeletonInventorySetting = () => {
    return (
        <BlockStack gap="500">
            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                    <BlockStack gap="200">
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className="Custom__Para--Skeleton">
                            <SkeletonBodyText lines={3} />
                        </div>
                    </BlockStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <div className="Custom__Button--Skeleton">
                        <SkeletonDisplayText size="medium" />
                    </div>
                </Grid.Cell>
            </Grid>
            <Divider />
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <div className="Custom__TextField--Skeleton">
                            <SkeletonDisplayText size="medium" />
                        </div>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <BlockStack gap="100">
                            <div className="Custom__TextField--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <BlockStack gap="100">
                            <div className="Custom__TextField--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <BlockStack gap="100">
                            <div className="Custom__TextField--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <InlineStack gap="200">
                            <div className="switch-skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom-Stack-Item--fill">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </div>
                        </InlineStack>
                        <InlineStack gap="200">
                            <div className="switch-skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom-Stack-Item--fill">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </div>
                        </InlineStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonEmailSetting = () => {
    return (
        <BlockStack gap="500">
            <BlockStack gap="200">
                <div className="Custom__Heading--Skeleton">
                    <SkeletonDisplayText size="small" />
                </div>
                <div className="Custom__Para--Skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>
            <Divider />
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <InlineStack gap="200">
                            <div className="switch-skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom-Stack-Item--fill">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </div>
                        </InlineStack>
                        <InlineStack gap="200">
                            <div className="switch-skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom-Stack-Item--fill">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                            </div>
                        </InlineStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonPriceSetting = () => {
    return (
        <BlockStack gap="500">
            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                    <BlockStack gap="200">
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className="Custom__Para--Skeleton">
                            <SkeletonBodyText lines={2} />
                        </div>
                    </BlockStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <div className="Custom__Button--Skeleton">
                        <SkeletonDisplayText size="medium" />
                    </div>
                </Grid.Cell>
            </Grid>
            <Divider />
            <BlockStack gap="300">
                <div className="Custom__PriceCalc--Skeleton">
                    <InlineStack gap="400" blockAlign="start">
                        <SkeletonThumbnail size="extraSmall" />
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={3} />
                        </BlockStack>
                    </InlineStack>
                </div>
                <Bleed marginInline='400'>
                    <Divider />
                </Bleed>
            </BlockStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <div className="Custom__Form--Group">
                                    <SkeletonDisplayText size="medium" />
                                </div>
                                <div className="Custom__Form--Group">
                                    <SkeletonDisplayText size="medium" />
                                </div>
                            </FormLayout.Group>
                        </FormLayout>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <BlockStack gap="200">
                            <FormLayout>
                                <FormLayout.Group condensed>
                                    <div className="Custom__Form--Group">
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                    <div className="Custom__Form--Group">
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                            <FormLayout>
                                <FormLayout.Group condensed>
                                    <div className="Custom__Form--Group">
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                    <div className="Custom__Form--Group">
                                        <SkeletonDisplayText size="medium" />
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <div className="Custom__Form--Group">
                                    <SkeletonDisplayText size="medium" />
                                </div>
                                <div className="Custom__Form--Group">
                                    <SkeletonDisplayText size="medium" />
                                </div>
                            </FormLayout.Group>
                        </FormLayout>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <FormLayout>
                            <FormLayout.Group condensed>
                                <div className="Custom__Form--Group">
                                    <SkeletonDisplayText size="medium" />
                                </div>
                                <div className="Custom__Form--Group">
                                    <SkeletonDisplayText size="medium" />
                                </div>
                            </FormLayout.Group>
                        </FormLayout>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonProductDetails = () => {
    return (
        <BlockStack gap="500">
            <BlockStack gap="0">
                <div className="Custom__Heading--Skeleton">
                    <SkeletonDisplayText size="small" />
                </div>
                <div className="Custom__Para--Skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
            </BlockStack>
            <Divider />
            <div className="Custom__Divider--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                        <div className="Custom__TextField--Skeleton">
                            <SkeletonDisplayText size="medium" />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <div className="Custom__Divider--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="300">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={5} />
                        </BlockStack>
                        <BlockStack gap="200">
                            <InlineStack gap="200">
                                <div className="switch-skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className="Custom-Stack-Item--fill">
                                    <div className="Custom__Subheading--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </div>
                            </InlineStack>
                            <InlineStack gap="200" blockAlign="center">
                                <div className="Custom__Thumbnail--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <div className="switch-skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className="Custom-Stack-Item--fill">
                                    <div className="Custom__Subheading--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </div>
                            </InlineStack>
                            <InlineStack gap="200" blockAlign="center">
                                <div className="Custom__Thumbnail--Skeleton">
                                    <SkeletonThumbnail size="extraSmall" />
                                </div>
                                <div className="switch-skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className="Custom-Stack-Item--fill">
                                    <div className="Custom__Subheading--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </div>
                            </InlineStack>
                            <InlineStack gap="200">
                                <div className="switch-skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <div className="Custom-Stack-Item--fill">
                                    <div className="Custom__Subheading--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                </div>
                            </InlineStack>
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonGlobalPrice = () => {
    return (
        <BlockStack gap="500">
            <BlockStack gap="200">
                <div className="Custom__Heading--Skeleton">
                    <SkeletonDisplayText size="small" />
                </div>
                <div className="Custom__Para--Skeleton">
                    <SkeletonBodyText lines={5} />
                </div>
            </BlockStack>
            <Card>
                <InlineStack gap="200">
                    <div className="Custom-Stack-Item--fill">
                        <BlockStack gap="100">
                            <SkeletonBodyText lines={1} />
                            <div className="Custom__TextField--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                        </BlockStack>
                    </div>
                    <div className="Custom-Stack-Item--fill">
                        <BlockStack gap="100">
                            <SkeletonBodyText lines={1} />
                            <div className="Custom__TextField--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                        </BlockStack>
                    </div>
                </InlineStack>
            </Card>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonOrder = () => {
    return (
        <BlockStack gap="500">
            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                    <BlockStack gap="200">
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className="Custom__Para--Skeleton">
                            <SkeletonBodyText lines={3} />
                        </div>
                    </BlockStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <div className="Custom__Button--Skeleton">
                        <SkeletonDisplayText size="medium" />
                    </div>
                </Grid.Cell>
            </Grid>
            <Banner>
                <SkeletonBodyText lines={3} />
            </Banner>
            <Divider />
            <BlockStack gap="800">
                <BlockStack gap="500">
                    <InlineStack gap="200">
                        <div className="switch-skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom-Stack-Item--fill">
                            <BlockStack gap="100">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </div>
                    </InlineStack>
                    <InlineStack gap="200">
                        <div className="switch-skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom-Stack-Item--fill">
                            <BlockStack gap="100">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </div>
                    </InlineStack>
                    <InlineStack gap="200">
                        <div className="switch-skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom-Stack-Item--fill">
                            <BlockStack gap="100">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <SkeletonBodyText lines={1} />
                            </BlockStack>
                        </div>
                    </InlineStack>
                    <InlineStack gap="200">
                        <div className="switch-skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom-Stack-Item--fill">
                            <BlockStack gap="300">
                                <BlockStack gap="100">
                                    <div className="Custom__Subheading--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                    <SkeletonBodyText lines={1} />
                                </BlockStack>
                                <BlockStack gap="200">
                                    <BlockStack gap="100">
                                        <div className="Custom__Subheading--Skeleton">
                                            <SkeletonBodyText lines={1} />
                                        </div>
                                        <SkeletonBodyText lines={3} />
                                    </BlockStack>
                                    <InlineStack gap="200">
                                        <div className="Custom-Stack-Item--fill">
                                            <BlockStack gap="100">
                                                <SkeletonBodyText lines={1} />
                                                <div className="Custom__TextField--Skeleton">
                                                    <SkeletonDisplayText size="medium" />
                                                </div>
                                            </BlockStack>
                                        </div>
                                        <div className="Custom-Stack-Item--fill">
                                            <BlockStack gap="100">
                                                <SkeletonBodyText lines={1} />
                                                <div className="Custom__TextField--Skeleton">
                                                    <SkeletonDisplayText size="medium" />
                                                </div>
                                            </BlockStack>
                                        </div>
                                    </InlineStack>
                                </BlockStack>
                            </BlockStack>
                        </div>
                    </InlineStack>
                    <InlineStack gap="200">
                        <div className="switch-skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom-Stack-Item--fill">
                            <BlockStack gap="100">
                                <div className="Custom__Subheading--Skeleton">
                                    <SkeletonBodyText lines={1} />
                                </div>
                                <SkeletonBodyText lines={2} />
                            </BlockStack>
                        </div>
                    </InlineStack>
                </BlockStack>
                <div className="Custom__Text--Skeleton">
                    <SkeletonDisplayText size="medium" />
                </div>
            </BlockStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="300">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <div className="Custom__TextField--Skeleton">
                            <SkeletonDisplayText size="medium" />
                        </div>
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <InlineStack gap="200">
                            <div className="Custom__Checkbox--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <div className="Custom-Stack-Item--fill Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </InlineStack>
                        <InlineStack gap="200">
                            <div className="Custom__Checkbox--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <div className="Custom-Stack-Item--fill Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </InlineStack>
                        <InlineStack gap="200">
                            <div className="Custom__Checkbox--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <div className="Custom-Stack-Item--fill Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </InlineStack>
                        <InlineStack gap="200">
                            <div className="Custom__Checkbox--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <div className="Custom-Stack-Item--fill Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </InlineStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

// export const RenderSkeletonOrderSync = () => {
//     return (
//         <BlockStack gap="500">
//             <BlockStack gap="300">
//                 <BlockStack gap="100">
//                     <div className="Custom__Heading--Skeleton">
//                         <SkeletonDisplayText size="small" />
//                     </div>
//                     <div className="Custom__Para--Skeleton">
//                         <SkeletonBodyText lines={3} />
//                     </div>
//                 </BlockStack>
//                 <Banner>
//                     <SkeletonBodyText lines={3} />
//                 </Banner>
//             </BlockStack>
//             <Divider />
//             <BlockStack gap="400">
//                 <BlockStack gap="100">
//                     <div className="Custom__Heading--Skeleton">
//                         <SkeletonDisplayText size="small" />
//                     </div>
//                     <div className="Custom__Para--Skeleton">
//                         <SkeletonBodyText lines={3} />
//                     </div>
//                 </BlockStack>
//                 <Card background="bg-surface-secondary">
//                     <BlockStack gap="200">
//                         <div className="Custom__Heading--Skeleton">
//                             <SkeletonDisplayText size="small" />
//                         </div>
//                         <div className="Custom__button--Skeleton">
//                             <InlineStack gap="200">
//                                 <SkeletonDisplayText size="small" />
//                                 <SkeletonDisplayText size="small" />
//                             </InlineStack>
//                         </div>
//                     </BlockStack>
//                 </Card>
//             </BlockStack>
//         </BlockStack>
//     );
// }

export const RenderSkeletonShipment = () => {
    return (
        <BlockStack gap="500">
            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                    <BlockStack gap="200">
                        <div className="Custom__Heading--Skeleton">
                            <SkeletonDisplayText size="small" />
                        </div>
                        <div className="Custom__Para--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </BlockStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <div className="Custom__Button--Skeleton">
                        <SkeletonDisplayText size="medium" />
                    </div>
                </Grid.Cell>
            </Grid>
            <Divider />
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={2} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <BlockStack gap="200">
                            <FormLayout>
                                <FormLayout.Group condensed>
                                    <div className="Custom__Form--Group">
                                        <BlockStack gap="100">
                                            <SkeletonBodyText lines={1} />
                                            <SkeletonDisplayText size="medium" />
                                        </BlockStack>
                                    </div>
                                    <div className="Custom__Form--Group">
                                        <BlockStack gap="100">
                                            <SkeletonBodyText lines={1} />
                                            <SkeletonDisplayText size="medium" />
                                        </BlockStack>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                            <div className="Custom__Buttons--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonCancellation = () => {
    return (
        <BlockStack gap="500">
            <BlockStack gap="200">
                <div className="Custom__Heading--Skeleton">
                    <SkeletonDisplayText size="small" />
                </div>
                <div className="Custom__Para--Skeleton">
                    <SkeletonBodyText lines={2} />
                </div>
            </BlockStack>
            <Divider />
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="100">
                        <div className="Custom__Subheading--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <SkeletonBodyText lines={1} />
                    </BlockStack>
                </div>
            </InlineStack>
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <InlineStack gap="200">
                            <div className="switch-skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom-Stack-Item--fill">
                                <BlockStack gap="100">
                                    <div className="Custom__Subheading--Skeleton">
                                        <SkeletonBodyText lines={1} />
                                    </div>
                                    <SkeletonBodyText lines={4} />
                                </BlockStack>
                            </div>
                        </InlineStack>
                        <BlockStack gap="200">
                            <FormLayout>
                                <FormLayout.Group condensed>
                                    <div className="Custom__Form--Group">
                                        <BlockStack gap="100">
                                            <SkeletonBodyText lines={1} />
                                            <SkeletonDisplayText size="medium" />
                                        </BlockStack>
                                    </div>
                                    <div className="Custom__Form--Group">
                                        <BlockStack gap="100">
                                            <SkeletonBodyText lines={1} />
                                            <SkeletonDisplayText size="medium" />
                                        </BlockStack>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                            <div className="Custom__Buttons--Skeleton">
                                <SkeletonDisplayText size="medium" />
                            </div>
                        </BlockStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}

export const RenderSkeletonTemplate = () => {
    return (
        <BlockStack gap="500">
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
            <Grid columns={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack align='space-between' blockAlign='center' gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__HeadingTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <div className="Custom__ParaTemplate--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </BlockStack>
                        <div className="Custom__Badge--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <InlineStack
                        gap={{ xs: "200", sm: "200", md: "200", lg: "800", xl: "800" }}
                        blockAlign='center'
                        align='end'>
                        <div className="Custom__ParaTemplate--Skeleton">
                            <SkeletonBodyText lines={1} />
                        </div>
                        <div className="Custom__Action--Skeleton">
                            <SkeletonThumbnail size="small" />
                        </div>
                    </InlineStack>
                </Grid.Cell>
            </Grid>
            <Divider />
        </BlockStack>
    );
}

export const RenderSkeletonLocalSelling = () => {
    return (
        <BlockStack gap="500">
            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                    <InlineStack gap="500" blockAlign="start">
                        <div className="Custom__PriceCalc--Skeleton">
                            <SkeletonThumbnail size="extraSmall" />
                        </div>
                        <BlockStack gap="200">
                            <div className="Custom__Heading--Skeleton">
                                <SkeletonDisplayText size="small" />
                            </div>
                            <div className="Custom__Para--Skeleton">
                                <SkeletonBodyText lines={3} />
                            </div>
                        </BlockStack>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <div className="Custom__Button--Skeleton">
                        <SkeletonDisplayText size="medium" />
                    </div>
                </Grid.Cell>
            </Grid>
            <Divider />
            <InlineStack gap="200">
                <div className="switch-skeleton">
                    <SkeletonBodyText lines={1} />
                </div>
                <div className="Custom-Stack-Item--fill">
                    <BlockStack gap="200">
                        <BlockStack gap="100">
                            <div className="Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                            <SkeletonBodyText lines={1} />
                        </BlockStack>
                        <InlineStack gap="200">
                            <div className="Custom__Checkbox--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <div className="Custom-Stack-Item--fill Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </InlineStack>
                        <InlineStack gap="200">
                            <div className="Custom__Checkbox--Skeleton">
                                <SkeletonThumbnail size="extraSmall" />
                            </div>
                            <div className="Custom-Stack-Item--fill Custom__Subheading--Skeleton">
                                <SkeletonBodyText lines={1} />
                            </div>
                        </InlineStack>
                    </BlockStack>
                </div>
            </InlineStack>
            <Divider />
            <div className="Custom__TextField--Skeleton">
                <SkeletonDisplayText size="medium" />
            </div>
        </BlockStack>
    );
}